import Slider from './slider';
import Component from './component';
import iconVolumeUp from '../assets/icons/volume-up.svg';
import iconVolumeMute from '../assets/icons/volume-mute.svg';
import iconVolumeDown from '../assets/icons/volume-down.svg';

// check if changing the volume is supported in the current environment
const volumeChangeSupported = (function () {
  const ua = navigator.userAgent.toLowerCase();
  const noVolume = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(ua);

  if (noVolume) {
    if (noVolume[0] === 'android' && /firefox/.test(ua)) {
      return true;
    } else {
      return false;
    }
  }

  if (!window.Audio) {
    return false;
  }

  const audio = new window.Audio();
  audio.volume = 0.5;

  return audio.volume === 0.5;
})();

export default class Volume extends Component {
  constructor (props) {
    props = Object.assign({
      volume: props.player.getVolume(),
      muted: props.player.getMute()
    }, props);

    super(props);

    this.handleEvent = this.handleEvent.bind(this);
    this.onmuteclick = this.onmuteclick.bind(this);

    if (volumeChangeSupported) {
      this.slider = new Slider({
        min: 0,
        max: 1,
        value: this.props.volume,
        step: 0.05,
        vertical: !!props.vertical,
        name: 'Change volume',
        onchange: event => {
          this.props.player.setVolume(this.slider.value);
          if (this.$element) {
            this.$element.classList.remove('iono-open');
          }
        }
      });
    }

    this.locale = this.props.player.locale;
    this.player = this.props.player;
    this.$mute = null;
    this.$muteLabel = null;
    this.$muteIcon = null;
  }

  onmuteclick (event) {
    this.player.setMute(!this.player.getMute());
  }

  getDefaultProps () {
    return {
      volume: 100,
      muted: false
    };
  }

  update () {
    const label = this.locale.player[this.props.muted ? 'unmute' : 'mute'];

    this.$mute.setAttribute('title', label);

    if (volumeChangeSupported) {
      this.slider.setProps({ value: this.props.volume });
    }

    if (this.$muteLabel) {
      this.$muteLabel.textContent = label;
    }

    if (this.$muteIcon) {
      this.$muteIcon.innerHTML = this.props.muted ? iconVolumeMute : (this.props.volume > 0.5 ? iconVolumeUp : iconVolumeDown);
    }
  }

  attach (element) {
    super.attach(element);

    this.$mute = this.$('.iono-player-toggle-mute');
    this.$muteLabel = this.$mute.querySelector('.iono-button-label');
    this.$muteIcon = this.$mute.querySelector('.iono-button-icon');

    this.props.player.on('volumechange', this.handleEvent);

    if (volumeChangeSupported) {
      this.slider.attach(this.$('.iono-slider'));
      this.$mute.addEventListener('click', this.onmuteclick);
      this.$element.addEventListener('mouseenter', this);
      this.$element.addEventListener('mouseleave', this);
    }
  }

  detach () {
    if (!this.$element) return;

    if (volumeChangeSupported) {
      this.slider.detach();
      this.$mute.removeEventListener('click', this.onmuteclick);
      this.$element.removeEventListener('mouseenter', this);
      this.$element.removeEventListener('mouseleave', this);
    }

    this.$mute = null;
    this.$muteLabel = null;
    this.$muteIcon = null;

    this.props.player.off('volumechange', this.handleEvent);

    super.detach();
  }

  handleEvent (event) {
    if (event.type === 'volumechange') {
      this.props.volume = event.volume;
      this.props.muted = event.muted;
      this.update();
    }

    if (event.type === 'mouseenter') {
      this.$element.classList.add('iono-open');
    }

    if (event.type === 'mouseleave' && !this.slider.sliding) {
      this.$element.classList.remove('iono-open');
    }
  }

  renderVolumeSlider () {
    if (!volumeChangeSupported) {
      return '';
    }

    return `
      <div class="iono-player-volume-slider">
        <div class="iono-slider">
          <div class="iono-slider-track"></div>
          <div class="iono-slider-progress"></div>
          <div class="iono-slider-container">
            <button class="iono-slider-knob" role="slider" aria-label="Change volume" aria-valuemin="0" aria-valuemax="1" aria-valuenow="${this.props.volume}"></button>
          </div>
        </div>
      </div>
    `;
  }

  render () {
    return `
      <div class="iono-player-volume iono-flex iono-align-items-center">
        <button class="iono-button iono-player-toggle-mute">
          <span class="iono-icon iono-button-icon" aria-hidden="true">${iconVolumeUp}</span>
          <span class="iono-button-label iono-sr-only">${this.locale.player.mute}</span>
        </button>
        ${this.renderVolumeSlider()}
      </div>
    `;
  }
}
